




































































































































































































import { defineComponent, reactive, toRefs, computed, ref, onMounted, onBeforeUnmount } from '@vue/composition-api';
import * as Common from "../../commons/common"
import moment from 'moment';
import http from "../../plugins/http";
import AlertArea from "../../components/AlertArea.vue";
import { Sheet, CramStudent } from "../../modules/student/ResultRankDetail"


export interface Data {
  sheet_id: string
  cram_student_id: string
  sheet: Sheet
  cram_student: CramStudent
  sumup_total_data: any
  sumup_part1_data: any[]
  sumup_field_data: any[]
  sort_part1_asc: boolean
  sort_class_state_asc: boolean
  sort_total_state_asc: boolean
  sort_correct_state_asc: boolean
  isExistsResultImage: boolean
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(props, context){

    /************************************************************
     * data
     ************************************************************/

    const state = reactive<Data>({
      sheet_id: context.root.$route.params.sheet_id,
      cram_student_id: context.root.$route.params.cram_student_id,
      sheet: new Sheet({}),
      cram_student: new CramStudent({}),
      sumup_total_data: {},
      sumup_part1_data: [],
      sumup_field_data: [],
      sort_part1_asc: true,
      sort_class_state_asc: true,
      sort_total_state_asc: true,
      sort_correct_state_asc: true,
      isExistsResultImage: false,
      errors: [],
    });

    /************************************************************
     * mounted
     ************************************************************/
    
    onMounted(async () => {

      const path: string = context.root.$route.fullPath;
      if(path.indexOf("student_site") != -1 && context.root.$route.params.cram_student_id != context.root.$store.state.cram_student_id){
        alert("画面の表示に失敗しました。URLが不正です。マイページからやり直してください。");
        window.close();
        window.history.back();
      }

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/result_rank_detail?sheet_id=${state.sheet_id}&cram_student_id=${state.cram_student_id}`).then(response => {
        state.sheet = new Sheet(response.data.sheet);
        state.cram_student = new CramStudent(response.data.cram_student);
        state.sumup_total_data = response.data.sumup_total_data;
        state.sumup_part1_data = response.data.sumup_part1_data;
        state.sumup_field_data = response.data.sumup_field_data;
        state.isExistsResultImage = response.data.is_exists_result_image;
      })
      .catch(error=>{
        // 後続処理不能のため一覧に戻る
        if(error.response.status == 422){
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。\n${error.response.data.errors[0]}`);
        }else{
          alert(`試験情報の取得処理に失敗しました。前の画面に戻ります。`);
        }
        window.history.back();
      });
      context.root.$store.dispatch("hideOverlay");
    });

    /************************************************************
     * 取込日用文言生成
     ************************************************************/

    const convertCaptureDate = (captureDate: string) => {
      return captureDate ? moment(captureDate).format('Y年M月D日') : "";
    };

    const rank_mongon = (rank: string) => {
      return rank ? rank + "位" : "-";
    };

    const total_mongon = (total: string) => {
      return total ? total + "位 / " : "-";
    };

    const getCorrectMark = (correct_state: number) => {
      switch (correct_state) {
        case -1:
          return "×"
          break;
        case 1:
          return "○"
          break;
        case 0:
          return "△"
          break;
      }
    };

    const getScoreName = (score: string) => {
      return score || score == "0" ? score + "点" : "-";
    };

    const getRankName = (rank: string, student_count: string) => {
      return rank ? rank + "位 / " + student_count + "人" : "-";
    };

    const getRateName = (rate: string) => {
      return rate || rate == "0" ? rate + "%" : "-";
    };

    const getDivisionName = (division: string) => {
      return division || division == "0" ? division : "-";
    };

    // 大問1を並び替え
    const sort_by_part1 = () => {
      if (state.sort_part1_asc) {
        // 昇順
        state.sumup_field_data.sort(function(a, b) {
          if (a.base_sheet_field_id <= b.base_sheet_field_id) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.sumup_field_data.sort(function(a, b) {
          if (a.base_sheet_field_id >= b.base_sheet_field_id) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_part1_asc = !state.sort_part1_asc
    };

    // クラス正答率を並び替え
    const sort_by_class_state = () => {
      if (state.sort_class_state_asc) {
        // 昇順
        state.sumup_field_data.sort(function(a, b) {
          if (parseFloat(a.class_correct_rate) >= parseFloat(b.class_correct_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.sumup_field_data.sort(function(a, b) {
          if (parseFloat(a.class_correct_rate) <= parseFloat(b.class_correct_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_class_state_asc = !state.sort_class_state_asc
    };

    // 全体正答率を並び替え
    const sort_by_total_state = () => {
      if (state.sort_total_state_asc) {
        // 昇順
        state.sumup_field_data.sort(function(a, b) {
          if (parseFloat(a.all_correct_rate) >= parseFloat(b.all_correct_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.sumup_field_data.sort(function(a, b) {
          if (parseFloat(a.all_correct_rate) <= parseFloat(b.all_correct_rate)) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_total_state_asc = !state.sort_total_state_asc
    };

    // 正誤を並び替え
    const sort_by_correct_state = () => {
      if (state.sort_correct_state_asc) {
        // 昇順
        state.sumup_field_data.sort(function(a, b) {
          if (a.correct_state >= b.correct_state) {
            return 1;
          } else {
            return -1;
          }
        });
      } else {
        // 降順
        state.sumup_field_data.sort(function(a, b) {
          if (a.correct_state <= b.correct_state) {
            return 1;
          } else {
            return -1;
          }
        });
      }
      state.sort_correct_state_asc = !state.sort_correct_state_asc
    };

    // 問題PDFダウンロード
    const downloadQuestionPdf = async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/result_rank_detail/download_question_pdf/${state.sheet.base_sheet_id}}`).then(response => {
        var mime_ctype = "application/pdf";
        var blob = toBlob(response.data.base64_pdf, mime_ctype);

        if (window.navigator.msSaveBlob) {
            // IEやEdgeの場合、Blob URL Schemeへと変換しなくともダウンロードできる
            window.navigator.msSaveOrOpenBlob(blob, "file.pdf"); 
        } else {
            // BlobをBlob URL Schemeへ変換してリンクタグへ埋め込む
            const downloadElm: HTMLElement = document.getElementById("download-pdf");
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(blob);
            a.download = `${state.sheet.name}_問題.pdf`;
            a.click();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    // 解説PDFダウンロード
    const downloadExplanationPdf = async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/result_rank_detail/download_explanation_pdf/${state.sheet.base_sheet_id}}`).then(response => {
        var mime_ctype = "application/pdf";
        var blob = toBlob(response.data.base64_pdf, mime_ctype);

        if (window.navigator.msSaveBlob) {
            // IEやEdgeの場合、Blob URL Schemeへと変換しなくともダウンロードできる
            window.navigator.msSaveOrOpenBlob(blob, "file.pdf"); 
        } else {
            // BlobをBlob URL Schemeへ変換してリンクタグへ埋め込む
            const downloadElm: HTMLElement = document.getElementById("download-pdf");
            const a = document.createElement('a');
            a.href = window.URL.createObjectURL(blob);
            a.download = `${state.sheet.name}_解説.pdf`;
            a.click();
        }
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    // 採点結果PDFダウンロード
    const downloadResultPdf = async () => {

      context.root.$store.dispatch("showOverlay", "データ取得中... しばらくお待ちください。");
      await http.get(`/api/result_rank_detail/download_result_pdf/${state.sheet_id}/${state.cram_student.student_code}`, {responseType: 'arraybuffer'}).then(response => {
        const blob = new Blob([response.data], { type: 'application/pdf' });
        const a = document.createElement('a');
        a.href = window.URL.createObjectURL(blob);
        a.download = `${state.sheet.name} 答案.pdf`;
        a.click();
      })
      .catch(error=>{
        if(error.response.status == 422){
          state.errors = error.response.data.errors;
        }else{
          state.errors = ["予期せぬ例外が発生しました。"];
        }
      });
      context.root.$store.dispatch("hideOverlay");
    };

    const toBlob = (base64: string, mime_ctype: string) => {
      // 日本語の文字化けに対処するためBOMを作成する。
      var bom = new Uint8Array([0xEF, 0xBB, 0xBF]);

      var bin = atob(base64.replace(/^.*,/, ''));
      var buffer = new Uint8Array(bin.length);
      for (var i = 0; i < bin.length; i++) {
          buffer[i] = bin.charCodeAt(i);
      }
      // Blobを作成
      try {
          var blob = new Blob([bom, buffer.buffer], {
              type: mime_ctype,
          });
      } catch (e) {
          return false;
      }
      return blob;
    };

    return {
      ...toRefs(state),
      convertCaptureDate,
      rank_mongon,
      total_mongon,
      getCorrectMark,
      getScoreName,
      getRankName,
      getRateName,
      getDivisionName,
      sort_by_part1,
      sort_by_class_state,
      sort_by_total_state,
      sort_by_correct_state,
      downloadQuestionPdf,
      downloadExplanationPdf,
      downloadResultPdf,
    };
  }
});

